module.exports = __webpack_public_path__ + "img/palabras2silabas.fw.ddc8e2f3.png";